import analytics from './mixpanel';

export const trackComponentProgressViewed = (
  completedCount: number,
  nextStep: 'facescan' | 'skinsync' | 'routine'
) => {
  analytics.track('component_progress_viewed', {
    completed_count: completedCount,
    next_step: nextStep,
  });
};

export const trackLockedFaceScoreViewed = (
  missingComponents: string[]
) => {
  analytics.track('locked_facescore_viewed', {
    missing_components: missingComponents,
  });
};

export const trackRoutineGradeAchieved = (
  grade: string,
  score: number,
  routineType: 'morning' | 'evening' | 'overall'
) => {
  analytics.track('routine_grade_achieved', {
    grade,
    score,
    routine_type: routineType,
    timestamp: new Date().toISOString(),
  });
};

export const trackNextGradeProgress = (
  currentGrade: string,
  nextGrade: string,
  pointsNeeded: number,
  suggestedStep: string | null
) => {
  analytics.track('next_grade_progress_viewed', {
    current_grade: currentGrade,
    next_grade: nextGrade,
    points_needed: pointsNeeded,
    suggested_step: suggestedStep,
  });
};

export const trackIncompleteProfileViewed = (
  completedCount: number,
  missingComponent: 'facescan' | 'skinsync' | 'routine',
  fromPage: string
) => {
  analytics.track('incomplete_profile_viewed', {
    completed_count: completedCount,
    missing_component: missingComponent,
    from_page: fromPage,
  });
};

export const trackHormonalProfileCompleted = (
  hormonalStatus: string,
  cyclePhase?: string | null
) => {
  analytics.track('hormonal_profile_completed', {
    hormonal_status: hormonalStatus,
    cycle_phase: cyclePhase || 'not_provided',
  });
};

export const trackHormonalProfileUpdated = (
  hormonalStatus: string,
  cyclePhase: string | null | undefined,
  updatedFrom: string | null
) => {
  analytics.track('hormonal_profile_updated', {
    hormonal_status: hormonalStatus,
    cycle_phase: cyclePhase || 'not_provided',
    previous_status: updatedFrom,
  });
};
